<template>
  <div class="w-max flex items-center gap-1 btn-shadow pill-content" :class="componentClass">
    <icon v-if="icon" :path="icon" h="h-5" w="w-5" class="pb-1" />
    <span>{{ text }}</span>
  </div>
</template>

<script>
import { computed } from 'vue'
import { colorsBg, colorsBorders, colorsOutline } from '@/colors.js'
import Icon from '@/components/Icon'

export default {
  name: 'Pill',
  components: {
    Icon
  },
  props: {
    text: String,
    type: {
      type: String,
      required: true
    },
    icon: String,
    small: Boolean,
    outline: Boolean
  },
  setup (props) {
    const componentClass = computed(() => {
      const base = [
        'border',
        props.small ? 'py-1 px-4' : 'py-1 px-4'
      ]

      return [
        ...base,
        props.outline ? colorsOutline[props.type] : [...colorsBg[props.type], colorsBorders[props.type]]
      ]
    })

    return {
      componentClass
    }
  }
}
</script>
